import { topicTags } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            探索当前最受关注的话题标签
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((tag, idx) => (
            <div
              key={idx}
              className="group inline-flex items-center gap-2.5 px-4 py-3 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-300/60 hover:bg-accent-50/50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 group-hover:bg-accent-200/80 transition-colors duration-200">
                <i className={`${tag.icon} text-accent-600 text-sm`}></i>
              </div>
              <div>
                <span className="text-sm font-medium text-foreground-900 block leading-tight">
                  #{tag.name}
                </span>
                <span className="text-xs text-foreground-400">{tag.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}